















import Vue from 'vue'

/* eslint-disable */ 
import { Dealer } from '../models/Dealer'
import { Make } from '../models/Make'
/* eslint-enable */

export default Vue.extend({
  computed: {
    currentDealer() : Dealer {
        return this.$store.state.dealers.currentDealer
      },
      currentMake() : Make {
        return this.$store.state.makes.currentMake
      },
    width() : number {
      return 150
    }
  },
  methods: {
    home(): void {
      const path = '/' + this.$route.params.makeId + '/' + this.$route.params.dealerCode
      if (this.$route.path !== path) {
        this.$store.commit('models/clearCurrentModel')
        this.$store.commit('trims/clearCurrentTrim')
        this.$router.push({ path: '/' + this.$route.params.makeId + '/' + this.$route.params.dealerCode })
      }
    }
  },
})
